const odataEndpoints = require('./odataEndpoints.json');

const getters = {};
odataEndpoints.forEach((odata) => {
  getters[odata.endPoint] = state => state[odata.endPoint];
  getters[odata.name] = state => state[odata.name];
});
export default getters;
